import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Button } from "./ui/button";
import { useState } from "react";
import { useEffect } from "react";
import { useProjectId } from "../context/ProjectIdContext";
import { Loader2, PencilLine, Trash2 } from "lucide-react";
import { Toast, ToastDescription, ToastTitle, ToastViewport } from "./ui/toast";
import { useContext } from "react";
import { UnitSystemContext } from "../context/UnitSystemContext";

const API_URL = process.env.REACT_APP_API_URL; // Ensure this matches your backend URL
const ProjectList = () => {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const credentials = `${username}:${password}`;
  const encodedCredentials = btoa(credentials); // Base64 encode the credentials

  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const { setProjectId } = useProjectId(); // Access setProjectId from context
  const [isLoading, setIsLoading] = useState(true);
  const [toastList, setToastList] = useState([]);
  const { setUnitSystem } = useContext(UnitSystemContext);
  // const [editingProjectId, setEditingProjectId] = useState(null);
  // const [editValues, setEditValues] = useState({});

  // Fetching Available Project
  useEffect(() => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const credentials = `${username}:${password}`;
    const encodedCredentials = btoa(credentials); // Base64 encode the credentials

    const fetchProjects = async () => {
      try {
        const token = localStorage.getItem("x-auth-token");
        // console.log(token);
        const response = await fetch(`${API_URL}/api/projects`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
            "x-auth-token": token,
          },
        });

        const responseData = await response.json();

        if (response.ok) {
          const fetchedProjects = responseData.data.projects; // Access projects from response

          // console.log("Projects fetched:", fetchedProjects);
          setProjects(fetchedProjects);
        } else {
          console.error("Failed to fetch projects:", responseData.message);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // const handleInputChange = (e, field, id) => {
  //   setEditValues((prev) => ({
  //     ...prev,
  //     [id]: {
  //       ...prev[id],
  //       [field]: e.target.value,
  //     },
  //   }));
  // };

  const handleProjectClick = (id) => {
    setProjectId(id); // Update the context with the selected projectId
    navigate("/designsummary", { state: { projectId: id } }); // Pass projectId to the /designsummary page
  };

  // Save edited project
  // const handleSaveEdit = async () => {
  //   if (!projectId) return;

  //   // Find the original project data
  //   const originalProject = projects.find((p) => p._id === projectId);

  //   // Ensure only updated fields are changed, while keeping others the same
  //   const updatedProject = {
  //     title: editValues[projectId]?.title ?? originalProject.title,
  //     location: editValues[projectId]?.location ?? originalProject.location,
  //     clientName:
  //       editValues[projectId]?.clientName ?? originalProject.clientName,
  //   };

  //   try {
  //     const token = localStorage.getItem("x-auth-token");
  //     const response = await fetch(`${API_URL}/api/project/${projectId}`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
  //         "x-auth-token": token,
  //       },
  //       body: JSON.stringify(updatedProject),
  //     });

  //     const responseData = await response.json();

  //     if (response.ok) {
  //       setProjects((prev) =>
  //         prev.map((project) =>
  //           project._id === projectId
  //             ? { ...project, ...updatedProject }
  //             : project
  //         )
  //       );
  //       setEditingProjectId(null);
  //       setToastList((prev) => [
  //         ...prev,
  //         {
  //           id: Date.now(),
  //           title: "SUCCESS!",
  //           description:
  //             responseData.data.message || "Project updated successfully",
  //           variant: "default",
  //         },
  //       ]);
  //     } else {
  //       setToastList((prev) => [
  //         ...prev,
  //         {
  //           id: Date.now(),
  //           title: "ERROR!",
  //           description:
  //             responseData.data?.message || "Failed to update project",
  //           variant: "destructive",
  //         },
  //       ]);
  //       console.error("Failed to update project");
  //     }
  //   } catch (error) {
  //     setToastList((prev) => [
  //       ...prev,
  //       {
  //         id: Date.now(),
  //         title: "ERROR!",
  //         description: "An error occurred.",
  //         variant: "destructive",
  //       },
  //     ]);
  //     console.error("Error updating project:", error);
  //   }
  // };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("x-auth-token");
      const response = await fetch(`${API_URL}/api/project/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        setToastList((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: "SUCCESS!",
            description:
              responseData.data?.message || "Project deleted successfully",
            variant: "destructive",
          },
        ]);

        setProjects((prev) => prev.filter((project) => project._id !== id));

        // Fetch fresh project list after a small delay to ensure consistency
        // setTimeout(() => {
        //   window.location.reload(); // Ensures latest data is fetched
        // }, 300);
      } else {
        setToastList((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: "ERROR!",
            description:
              responseData.data?.message || "Failed to delete project",
            variant: "destructive",
          },
        ]);
        console.error("Failed to delete project");
      }
    } catch (error) {
      setToastList((prev) => [
        ...prev,
        {
          id: Date.now(),
          title: "ERROR!",
          description: "An error occurred.",
          variant: "destructive",
        },
      ]);
      console.error("Error deleting project:", error);
    }
  };

  if (isLoading) {
    return (
      <div className="tw-flex tw-items-center tw-justify-center tw-h-screen">
        <Loader2 className="tw-animate-spin tw-h-10 tw-w-10 tw-text-[#00B5ED]" />
      </div>
    );
  }

  const handleClearProjectInfo = () => {
    setUnitSystem("imperial"); // Default to imperial
    localStorage.setItem("savedUnitSystem", "imperial"); // Store default unit system
    localStorage.removeItem("projectInfo"); // Clear project info
    console.log("New project: Reset to imperial and cleared project info.");
  };

  const removeToast = (id) => {
    setToastList((prev) => prev.filter((toast) => toast.id !== id));
  };

  // const projects = [
  //   {
  //     id: 1,
  //     title: "Project Alpha",
  //     description: "Description of Project Alpha.",
  //   },
  //   {
  //     id: 2,
  //     title: "Project Beta",
  //     description: "Description of Project Beta.",
  //   },
  //   {
  //     id: 3,
  //     title: "Project Gamma",
  //     description: "Description of Project Gamma.",
  //   },
  // ];

  return (
    <div className="tw-min-h-screen tw-px-4 tw-pt-6">
      {/* Header Buttons */}
      <div className="tw-flex tw-justify-end tw-mb-6 tw-space-x-4">
        <Link to="/projectinfo">
          <Button
            onClick={handleClearProjectInfo}
            className="tw-bg-[#00B5ED] tw-text-white hover:tw-bg-[#009ECC]"
          >
            Add New Project
          </Button>
        </Link>
        {/* <Link to="/">
          <Button className="tw-text-white hover:tw-bg-[#009ECC]">
            History
          </Button>
        </Link> */}
      </div>

      {/* Projects List */}
      <div className="tw-grid tw-gap-6 tw-cursor-pointer">
        {projects.length === 0 ? (
          <p className="tw-text-center tw-text-gray-500">
            No projects to display.
          </p>
        ) : (
          projects.map((project) => (
            <Card
              key={project._id}
              className="tw-w-full tw-shadow-sm tw-flex tw-justify-between tw-items-center"
            >
              <div
                className="tw-w-1/2"
                // onClick={() => {
                //   if (editingProjectId !== project._id) {
                //     handleProjectClick(project._id);
                //   }
                // }}
                onClick={() => {
                  handleProjectClick(project._id);
                }}
              >
                <CardHeader className="tw-pb-2">
                  {/* Toggle between inputs and normal display
                  {editingProjectId === project._id ? (
                    <>
                      <div className="tw-flex tw-space-x-2">
                        <input
                          type="text"
                          value={
                            editValues[project._id]?.title || project.title
                          }
                          onChange={(e) =>
                            handleInputChange(e, "title", project._id)
                          }
                          className="tw-border tw-bg-[#F2F2F2] tw-rounded tw-p-2 tw-w-full"
                          placeholder="Project title"
                        />
                        <input
                          type="text"
                          value={
                            editValues[project._id]?.location ||
                            project.location
                          }
                          onChange={(e) =>
                            handleInputChange(e, "location", project._id)
                          }
                          className="tw-border tw-bg-[#F2F2F2] tw-rounded tw-p-2 tw-w-1/2"
                          placeholder="Project location"
                        />
                      </div>

                      <input
                        type="text"
                        value={
                          editValues[project._id]?.clientName ||
                          project.clientName
                        }
                        onChange={(e) =>
                          handleInputChange(e, "clientName", project._id)
                        }
                        className="tw-border tw-bg-[#F2F2F2] tw-rounded tw-p-2 tw-w-full"
                        placeholder="Client name"
                      />
                    </>
                  )  */}
                  <>
                    <CardTitle className="tw-text-lg tw-font-bold tw-text-[#00B5ED]">
                      {project.title}
                    </CardTitle>
                    <CardDescription className="tw-text-gray-600 tw-pt-2 ">
                      <span className="tw-font-semibold tw-text-gray-600">
                        Location:
                      </span>{" "}
                      {project.location}{" "}
                      <span className="tw-mx-4 tw-text-gray-400">|</span>{" "}
                      <span className="tw-font-semibold tw-text-gray-600">
                        Client:
                      </span>{" "}
                      {project.clientName}
                    </CardDescription>
                  </>
                </CardHeader>
                <CardContent>
                  <p className="tw-text-sm tw-text-gray-600">
                    <span className="tw-font-semibold">Design Date:</span>{" "}
                    {new Date(project.sippCalcDesignDate).toLocaleDateString()}
                  </p>
                </CardContent>
              </div>

              <div className="tw-flex tw-space-x-4 tw-px-4">
                {/* Toggle between Edit and Save
                {editingProjectId === project._id ? (
                  <Button
                    onClick={handleSaveEdit}
                    className="tw-bg-green-500 tw-text-white hover:tw-bg-green-600"
                  >
                    <Check className="tw-w-5 tw-h-5" />
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      setProjectId(project._id);
                      setEditingProjectId(project._id);
                    }}
                    className="tw-bg-[#00B5ED] tw-text-white hover:tw-bg-primary/90"
                  >
                    <PencilLine className="tw-w-5 tw-h-5" />
                  </Button>
                )} */}

                <Button
                  onClick={() => {
                    setProjectId(project._id); // Store project ID in context

                    // Get the existing projectInfo from localStorage
                    const existingProject =
                      JSON.parse(localStorage.getItem("projectInfo")) || {};

                    const savedProject = {
                      ...project,
                      resin: project.resin ?? existingProject.resin ?? "", // Keep last selected resin
                    };

                    localStorage.setItem(
                      "projectInfo",
                      JSON.stringify(savedProject),
                    );
                    navigate("/projectinfo", { state: { isEditing: true } }); // Navigate with an editing flag
                  }}
                  className="tw-bg-[#00B5ED] tw-text-white hover:tw-bg-primary/90"
                >
                  <PencilLine className="tw-w-5 tw-h-5" />
                </Button>

                <Button
                  onClick={() => handleDelete(project._id)}
                  className="tw-bg-destructive tw-text-white hover:tw-bg-destructive/90"
                >
                  <Trash2 className="tw-w-5 tw-h-5" />
                </Button>
              </div>
            </Card>
          ))
        )}
      </div>

      {/* Toast Notifications */}
      <ToastViewport />
      {toastList.map(({ id, title, description, variant }) => (
        <Toast
          key={id}
          variant={variant}
          open={true}
          duration={Infinity}
          onOpenChange={(isOpen) => {
            if (!isOpen) removeToast(id);
          }}
          className="tw-flex tw-flex-col tw-text-center"
        >
          <ToastTitle>{title}</ToastTitle>
          <ToastDescription>{description}</ToastDescription>

          {/* Close Button */}
          <button
            onClick={() => removeToast(id)}
            className="tw-mt-3 tw-self-center tw-text-sm tw-font-medium tw-bg-white tw-px-2 tw-py-1 tw-text-black hover:tw-bg-white/80"
          >
            Close
          </button>
        </Toast>
      ))}
    </div>
  );
};

export default ProjectList;
